import { christmasPath } from "../../paths";

export const seoImageUrl = `${christmasPath}/images/facebook.jpg`;
